import React from 'react';
import PropTypes from 'prop-types';
import SectionAccordion from './SectionAccordion.js';
import getHTMLElement from '../lib/setHtmlHelper';
import getContent from 'pp-react-l10n';

export default class Faqcomponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showItems: 4
    };
  }

  /* eslint-disable react/no-danger */
  render() {
    const country = (this.props.country).toLowerCase();
    const getFaqHeading = getContent('staticContent');
    const faqs = this.props.articleInfo.content.faqs || [{}];
    const newFaqs = faqs.filter(value => Object.keys(value).length !== 0);
    if (newFaqs.length > 0) {
      return (
        <div className="qasContainer" id="qa-Container">
          <div className="main">
        <h2 className="faq-title">{getFaqHeading('brc.faqHeading')}</h2>
        {newFaqs.slice(0, this.state.showItems).map(function (faq, index) {
          const questionHtml  = getHTMLElement(faq.question, {useHTML: true });
          const answerHtml = getHTMLElement(faq.answer, {useHTML: true });
          return (
          <div key={index}>
          <div className="faq-bordeline" />
          <SectionAccordion country = {country} title={questionHtml}
            key={faq.question + index}>
            <div>{answerHtml}</div>
          </SectionAccordion>
          </div>
          );
        })}
        <div className="faq-bordeline" />
      </div>
      </div>
      );
    }
    return (<span/>);
  }
}

Faqcomponent.propTypes = {
  articleInfo: PropTypes.shape({
    content: PropTypes.shape({
      faqs: PropTypes.array
    })
  }),
  country: PropTypes.string
};
